<app-nav> </app-nav>
<div class="new-screen1">
  <div class="container flex flex-col justify-center items-center">
    <div class="flex max-sm:!flex-col sm:flex-row max-sm:!gap-[10px] sm:gap-[10px]">

      @if (pdf_list?.length > 0) {
        @for (pdf of pdf_list; track pdf) {
          <div class="max-sm:!flex-[1_1_100%] sm:flex-[1_1_50%] self-center">
            <div class="flex justify-center items-center">
              <mat-card style="max-width: 250px;">
                <a [routerLink]="['/aoc-2020/pdf/' + pdf['slug']]" style="cursor: pointer;">
                  <div class="flex justify-center items-center">
                    <img src="{{pdf['image_url']}}" width="100%" alt="TheRightDoctors">
                  </div>
                  <h6 style="text-align: center; padding-top: 5px;" class="tv-drname-btm" >{{ pdf['sub_headline']}}</h6>
                  <h5 class="tv-headline-btm"style="text-align:center;padding-top: 5px;" >{{ pdf['headline'] |slice:0:60}}</h5>
                </a>
                <div style="padding-top: 5px; padding-bottom: 2px;" class="flex justify-center items-center">
                  <button (click) = "downloadImage(pdf['url'])">Download PDF</button>
                </div>
              </mat-card>
            </div>
          </div>
        }
      }
      <!--

      <div   fxFlex.lt-md="50%" >
        <mat-card fxLayout="column" >
          <a [routerLink]="['/aoc-2020/pdf/dr-dev-pahlajani-pci-in-women-are-outcomes-different-in-men']" style="cursor: pointer;">
            <div >
              <span></span>
              <img src="https://storage.googleapis.com/web-assets/aoc-mumbai/dr-dev-pahlajani-pci-in-women-are-outcomes-different-in-men.PNG" alt="TheRightDoctors">
            </div>
            <h6 class="tv-drname-btm">Dr. Dev Pahlajani</h6>
            <h5 class="tv-headline-btm">PCI in Women: Are Outcomes different in Men</h5></a>
            <br>
              <button (click) = "downloadImage('https://storage.googleapis.com/web-assets/AOC-2020/Dev%20Pahlajani.pdf')">Download PDF</button>
            </mat-card>
          </div>

          <div fxFlex.lt-md="50%" >
            <mat-card fxLayout="column"  >
              <a [routerLink]="['/aoc-2020/pdf/dr-nanette-kas-wenger-transforming-cvd-prevention-for-women']" style="cursor: pointer;">
                <div >
                  <span></span>
                  <img src="https://storage.googleapis.com/web-assets/aoc-mumbai/dr-nanette-kas-wenger-transforming-cvd-prevention-for-women.PNG" alt="TheRightDoctors">
                </div>
                <h6 class="tv-drname-btm">Dr. Nanette Kas</h6>
                <h5 class="tv-headline-btm">Transforming CVD prevention for Women</h5></a>
                <br>
                  <button (click) = "downloadImage('https://storage.googleapis.com/web-assets/AOC-2020/Wenger%202.pdf')">Download PDF</button>
                </mat-card>
              </div> -->
            </div>
          </div>
        </div>
        <app-footer></app-footer>
